import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CoreUiModule } from '../../core-ui/core-ui.module';
import { PeopleSelectorComponent } from './PeopleSelector.component';

@NgModule({
    imports: [CommonModule, FormsModule, CoreUiModule],
    declarations: [PeopleSelectorComponent],
    exports: [PeopleSelectorComponent],
    providers: []
})
export class PeopleSelectorModule {}
